import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import PageAuthorize from '../../../../security/PageAuthorize';
import ByFilename from './ByFilename';
import ByDNIS from './ByDNIS';

class FileManagement extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      selected: 'ByFilename',
      content: <ByFilename />
    };

    this.onClickByFilename = this.onClickByFilename.bind( this );
    this.onClickByDNIS = this.onClickByDNIS.bind( this );
  }

  onClickByFilename( event ) {
    this.setState( {
      selected: 'ByFilename',
      content: <ByFilename />
    } );
  }

  onClickByDNIS( event ) {
    this.setState( {
      selected: 'ByDNIS',
      content: <ByDNIS />
    } );
  }

  render() {
    let byFilename = this.state.selected === 'ByFilename';

    return (
      <PageAuthorize groups={['Administrators', 'Operations', 'Management']}>
        <div className='file-management-main-container'>
          <div className='file-management-worksheet-container'>
            <div className='file-management-header'>
              <span className='file-management-header-heading'>File Management</span>
              <span className='file-management-grid-view-tabs'>
                <button className={byFilename ? 'file-management-grid-view-tab-button-selected' : 'file-management-grid-view-tab-button'} onClick={this.onClickByFilename} title='p_api_fl_file_search'>Search by Filename</button>
                <button className={!byFilename ? 'file-management-grid-view-tab-button-selected' : 'file-management-grid-view-tab-button'} onClick={this.onClickByDNIS} title='p_api_file_upload_search'>Search by DNIS</button>
              </span>
            </div>
            {this.state.content}
          </div>
        </div>
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( FileManagement )
);


// WEBPACK FOOTER //
// ./src/content/enterprise/filemanagement/components/FileManagement.js